module.exports = __webpack_public_path__ + "static/img/logo.dc528a5e.svg";